export const ANGULAR_PREFIX = 'da';
export const BUFFERED_REQUEST_STORAGE_PREFIX = 'buffered-requests';
export const METADATA_STORAGE_PREFIX = 'PostToBackendFromLocalStorage:Metadata:';
export const EXTENSION_FRAME_ID = `${ANGULAR_PREFIX}-extension-frame`;
export const EXTENSION_NAME_LEARN_AND_EARN_FRIENDLY = 'Timeback Adapter';
export const EXTENSION_NAME_LEARN_AND_EARN_OFFICIAL = 'TimebackAdapter';
export const EXTENSION_NAME_LEARN_WITH_AI_FRIENDLY = 'Timeback Adapter';
export const EXTENSION_NAME_LEARN_WITH_AI_OFFICIAL = 'TimebackAdapter';
